
export const setClasses = (...classes: any[]) => {
    return classes.map((className) => className).join(" ");
};
export function mountStyles(stylesStr: any) {
    const styleTag = document.createElement('style');
    styleTag.textContent = stylesStr;
    document.head.appendChild(styleTag);
}
